<template>
  <tr :class="{'warning': !finalMealId || loading, 'danger': showError || servingNotExists }">
    <th>{{ mealType.name }}</th>
    <th>
      <div v-for="badge in selectedMealBadges" :key="badge.id">
        <a @click.prevent="showMealBadge(badge.id)">
          <i class="fa fa-link"></i>&nbsp;{{ badge.name }}
        </a>
      </div>
    </th>
    <td class="active menu-planner-meal-row">
      <div v-show="mealsLoading && !loading" class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></div>
      <singleselect
          :checked="finalMealId"
          :disabled="!canEdit || loading"
          :options="availableMeals"
          :internal-search="false"
          :title="trans('menu_planner.entity.finalMeal')"
          name="finalMeal"
          @option-selected="save($event)"
          @search-change="getMeals($event, 500)"
          @open="!fetchMealsTimeout && getMeals(null, 0)"
      />
    </td>
    <td>
      <span v-if="loading" class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>
      <span v-else>{{ finalMealId }}</span>
    </td>
    <td>
      <span v-if="loading" class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>
      <span v-else>{{ selectedMealRate }}</span>
    </td>
    <td v-if="loading">
      <span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>
    </td>
    <td v-else>
      <span v-for="(tagValue, index) in selectedMealTagValues" :key="index">
        {{ tagValue }}
        <br>
      </span>
    </td>
    <td
        v-for="(basket, index) in baskets"
        :key="index"
        :class="{'active': index % 2 === 0, '': index % 2 !== 0}"
    >
      <table style="table-layout: fixed; width: 600px;">
        <tr>
          <td style="width: 500px">{{ servingName(basket) }}</td>
          <td style="width: 100px">{{ basketSize(basket) }}</td>
        </tr>
      </table>
    </td>
  </tr>
</template>

<script>
import moment from 'moment'
import toastr from '@js/toastr'
import mixins from '@js/mixins.js'
import singleselect from '@component/singleselect.vue'

export default {
  components: {
    singleselect,
  },
  mixins: [mixins],
  props: {
    date: {
      type: [String, Date],
      default: ''
    },
    brand: {
      type: [String, Number],
      default: ''
    },
    mealType: {
      type: Object,
      default: () => ({}),
    },
    variant: {
      type: Object,
      default: () => ({}),
    },
    initialBaskets: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      selectedMealId: null,
      loading: false,
      mealsLoading: false,
      meals: [],
      fetchedMeal: null,
      fetchMealsTimeout: null,
      showError: false,
      baskets: this.initialBaskets,
    }
  },
  computed: {
    canEdit() {
      return (new moment(this.date)).unix() >= (new moment((new moment()).format('YYYY-MM-DD'))).unix()
    },
    selectedMeal() {
      return this.availableMeals.find(meal => meal.id === this.finalMealId)
    },
    selectedMealRate() {
      return this.selectedMeal ? this.dcNumberFormat(this.selectedMeal.rate) : ''
    },
    selectedMealTagValues() {
      return this.selectedMeal ? this.selectedMeal.tagValues : []
    },
    selectedMealBadges() {
      return this.selectedMeal
        ? this.selectedMeal.mealBadges.reduce((acc, mealBadge) => {
          if (mealBadge.validFrom <= this.date && mealBadge.validTo >= this.date) {
            acc.push(mealBadge.badge)
          }

          return acc
        }, [])
        : []
    },
    availableMeals() {
      let meals = [...this.meals]

      if (this.finalMealId && !meals.some(meal => meal.id === this.finalMealId) && this.basketMeal) {
        meals = [this.basketMeal, ...meals]
      }

      return meals
    },
    copyDateData() {
      return this.$store.state.dateData
    },
    mealId() {
      const meal = this.basketMeal
      return meal ? meal.id : null
    },
    finalMealId() {
      return this.selectedMealId || this.mealId || null
    },
    mealNotExists() {
      if (!this.finalMealId && !this.loading) {
        return false
      }

      for (let i = 0; i < this.baskets.length; i++) {
        let mps = this.menuPlannerServing(this.baskets[i])

        if (mps) {
          return false
        }
      }

      return true
    },
    servingNotExists() {
      if (window.location.hash.includes('copySuccess=true') && !this.finalMealId) {
        return true
      }

      if (this.finalMealId && !this.loading) {
        for (let i = 0; i < this.baskets.length; i++) {
          if (this.basketSize(this.baskets[i]) && !this.servingName(this.baskets[i])) {
            return true
          }
        }
      }

      return false
    },
    basketMeal() {
      for (let i = 0; i < this.baskets.length; i++) {
        let mps = this.menuPlannerServing(this.baskets[i])

        if (typeof mps !== 'undefined' && mps !== null) {
          return mps.serving.meal
        }
      }

      return null
    },
    getBasketMeals() {
      let basketMeals = []

      for (let i = 0; i < this.baskets.length; i++) {
        for (let j = 0; j < this.baskets[i].basketMeals.length; j++) {
          if (this.baskets[i].basketMeals[j].mealType.id === this.mealType.id) {
            basketMeals.push(this.baskets[i].basketMeals[j].id)
          }
        }
      }

      return basketMeals
    },
  },
  watch: {
    async copyDateData() {
      const mealData = this.$store.state.dateData.find(
        d => (d.variant_id === this.variant.id && d.meal_type_id === this.mealType.id)
      )

      if (mealData) {
        await this.save({ id: mealData.meal_id })
      } else {
        this.showError = true
        toastr.warning(this.trans('menu_planner.error.meal_not_found_for_brand'), null, { timeOut: 5000 })
      }
    },
  },
  methods: {
    mealExist(finalMealId) {
      for (let i = 0; i < this.availableMeals.length; i++) {
        if (Number(this.availableMeals[i].id) === Number(finalMealId)) {
          return true
        }
      }

      return false
    },
    basketSize(basket) {
      for (let i = 0; i < basket.basketMeals.length; i++) {
        if (basket.basketMeals[i].mealType.id === this.mealType.id) {
          return basket.basketMeals[i].size.name
        }
      }
    },
    menuPlannerServing(basket) {
      for (let i = 0; i < basket.basketMeals.length; i++) {
        if (basket.basketMeals[i].mealType.id === this.mealType.id) {
          return basket.basketMeals[i].menuPlannerServings[0]
        }
      }

      return null
    },
    servingName(basket) {
      let mps = this.menuPlannerServing(basket)

      if (typeof mps !== 'undefined' && mps !== null) {
        return mps.serving.name
      }
    },
    showMealBadge(badgeId) {
      window.open(Routing.generate('badge_show', { id: badgeId }), '_blank')
    },
    save(meal) {
      this.showError = false
      this.selectedMealId = meal !== null ? meal.id : null

      const url = Routing.generate('api_post_menu_planner')
      const data = {
        meal: this.selectedMealId,
        mealType: this.mealType.id,
        date: this.date,
        basketMeals: this.getBasketMeals,
        variant: this.variant.id,
      }

      this.loading = true
      return this.$http.post(url, data)
        .then(response => {
          this.baskets = response.data
          this.$emit('update-baskets-details')

          if (this.mealNotExists) {
            toastr.warning(this.trans('menu_planner.serving_not_exists'), null, { timeOut: 5000 })
            this.showError = true
          } else {
            toastr.success(this.trans('form.updated'), null, { timeOut: 5000 })
          }

          this.selectedMealId = null
          this.loading = false
        }, response => {
          this.handleAjaxError(response)

          this.showError = true
          this.selectedMealId = null
          this.loading = false
        })
    },
    getMeals(name, timeout) {
      if (this.fetchMealsTimeout) {
        this.mealsLoading = false
        clearTimeout(this.fetchMealsTimeout)
      }

      const params = {
        'brand_id': this.brand,
        'meal_type_id': this.mealType.id,
        'variant_id': this.variant.id,
        'date': this.date,
      }

      if (name) {
        params.name = name
      }

      this.mealsLoading = true
      this.fetchMealsTimeout = setTimeout(() => {
        this.$http.get(Routing.generate('api_get_meals_final_by_meal_type', params))
          .then(response => {
            this.meals = response.data
            this.mealsLoading = false
          }, response => {
            this.handleAjaxError(response)
            this.mealsLoading = false
          })
      }, timeout)
    },
  }
}
</script>

<style scoped>
.menu-planner-meal-row {
  position: relative;
}

.menu-planner-meal-row .glyphicon-refresh {
  position: absolute;
  top: 20px;
  right: 55px;
  z-index: 2;
}
</style>
